import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=7a0880d0&scoped=true&"
import script from "./Display.vue?vue&type=script&lang=js&"
export * from "./Display.vue?vue&type=script&lang=js&"
import style0 from "./Display.vue?vue&type=style&index=0&id=7a0880d0&lang=scss&scoped=true&"
import style1 from "./Display.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0880d0",
  null
  
)

/* custom blocks */
import block0 from "./Display.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "Display.vue"
export default component.exports